type Props = {
  msg?: string;
};

export const DataNotFound = ({ msg = 'データが存在しません' }: Props) => (
  <div className="p-4 text-center">
    <p className="text-gray-500">{msg}</p>
  </div>
);
